import { render, staticRenderFns } from "./BoldTerminalSelector.vue?vue&type=template&id=3c5a179e&scoped=true&"
import script from "./BoldTerminalSelector.vue?vue&type=script&lang=js&"
export * from "./BoldTerminalSelector.vue?vue&type=script&lang=js&"
import style0 from "./BoldTerminalSelector.vue?vue&type=style&index=0&id=3c5a179e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a179e",
  null
  
)

export default component.exports